export default {
  title: "Sub Estatus"
  , vacio: "VACÍO"
  , form: {
    code: {
      label: "Código"
      , th: "Código"
    }
    , vacio: { label: "Aplica sub estatus vacío" }
    , descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
    , accion: {
      label: "Acciones"
      , th: "Acciones"
    }
    , statusprecontacto: {
      label: "Status Pre Contacto"
      , th: "Status Pre Contacto"
    }
    , postest: {
      label: "Pos Test"
      , th: "Pos Test"
    }
    , canalaceptacion: { label: "Canal Aceptación" }
    , tipo: {
      label: "Tipo"
      , th: "Tipo"
    }
    , popentry: {
      label: "Pop Entry"
      , th: "Pop Entry"
    }
    , popexit: {
      label: "Pop Exit"
      , th: "Pop Exit"
    }
    , direccion: { label: "Validar Dirección" }
    , provincia: { label: "Validar Provincia" }
    , localidad: { label: "Validar Localidad" }
    , codigopostal: { label: "Validar Código Postal" }
    , telefono: { label: "Validar Teléfono" }
    , email: { label: "Validar Email" }
    , whatsapp: { label: "Validar WhatsApp" }
    , iniciativa: { label: "Iniciativa" }
    , clonable: { label: "Clonable" }
    , payfac: {
      label: "Payfac"
      , th: "PAYFAC"
    }
    , gaps: {
      label: "Gaps"
      , th: "GAPS"
    }
  }
  , filters: {
    descripcion: "Descripción"
    , payfac: "Payfac"
    , gaps: "Gaps"
    , status: "Status"
    , accion: "Acciones"
    , statusprecontacto: "Status Pre Contacto"
    , postest: "Pos Test"
    , canalaceptacion: "Canal Aceptación"
    , tipo: "Tipo"
    , clonable: "Clonable"
  }
  , errors: {
    BD5001: { text: "Ocurrió un error en el catálogo de Sub Estatus" }
    , WS5001: { text: "Ocurrió un error en el catálogo de Sub Estatus" }
    , JS5001: { text: "Ocurrió un error en el catálogo de Sub Estatus" }
    , CR5001: { text: "Ocurrió un error en el catálogo de Sub Estatus" }
    , UK_SubStatus: { text: "Ya existe un registro con los mismos datos" }
    , UK_SubStatus_code: { text: "Ya existe un registro con el mismo código" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/substatus.js